import { Navigate, Route, Routes } from 'react-router-dom';

import { RequireAuth } from './auth/RequireAuth';
import { AnalyticsPage } from './features/analytics/AnalyticsPage';
import { AuditPage } from './features/audit/AuditPage';
import { DictionariesPage } from './features/dictionaries/DictionariesPage';
import { ExportsPage } from './features/exports/ExportsPage';
import { ModerationPage } from './features/moderation/ModerationPage';
import { NotificationsPage } from './features/notifications/NotificationsPage';
import { RegistryPage } from './features/registry/RegistryPage';
import { RolesPage } from './features/roles/RolesPage';
import { EnterpriseRequestsPage } from './features/requests/EnterpriseRequestsPage';
import { LoginPage } from './pages/LoginPage';

/** Маршруты панели администратора региона (ТЗ FR-ADM-01…06, FR-NTF-03). */
export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/analytics"
        element={
          <RequireAuth>
            <AnalyticsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/moderation"
        element={
          <RequireAuth>
            <ModerationPage />
          </RequireAuth>
        }
      />
      <Route
        path="/dictionaries"
        element={
          <RequireAuth>
            <DictionariesPage />
          </RequireAuth>
        }
      />
      <Route
        path="/roles"
        element={
          <RequireAuth>
            <RolesPage />
          </RequireAuth>
        }
      />
      <Route
        path="/requests"
        element={
          <RequireAuth>
            <EnterpriseRequestsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/exports"
        element={
          <RequireAuth>
            <ExportsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/registry"
        element={
          <RequireAuth>
            <RegistryPage />
          </RequireAuth>
        }
      />
      <Route
        path="/notifications"
        element={
          <RequireAuth>
            <NotificationsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/audit"
        element={
          <RequireAuth>
            <AuditPage />
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate to="/analytics" replace />} />
    </Routes>
  );
}
